import { useCallback, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Button } from '@beatq/ui';
import { useOnlineStatus } from '@beatq/shared';
import { PinSignInModal } from '../staff-pin/PinSignInModal.js';
import { FloorExitControl } from './FloorModePages.js';
import { floorModeSwitcherPath, markFloorSession } from './floorModeState.js';
import { useFloorIdleTimeout } from './useFloorIdleTimeout.js';
import { useFloorWriteQueue } from './useFloorWriteQueue.js';

/** NAV-8: floor chrome is one exit (with confirm) and nothing else. */
export function MerchantFloorLayout() {
  const { pathname } = useLocation();
  const onSwitcher = pathname === floorModeSwitcherPath();
  const onKitchenDisplay = pathname === '/kitchen-display';
  const online = useOnlineStatus();
  const { queuedCount, drain } = useFloorWriteQueue();
  const [pinOpen, setPinOpen] = useState(false);

  const openPinLock = useCallback(() => {
    markFloorSession(false);
    setPinOpen(true);
  }, []);

  useFloorIdleTimeout(true, openPinLock);

  const showQueue = !online || queuedCount > 0;
  const showExit = !onSwitcher && !onKitchenDisplay;
  const showChrome = showExit || showQueue;

  return (
    <div data-layout="floor" data-theme="floor" className="min-h-screen bg-page text-default">
      {showChrome ? (
        <header className="mer-floor-chrome m09-floor-chrome" data-testid="merchant-floor-chrome">
          {showExit ? <FloorExitControl /> : null}
          {showQueue ? (
            <div
              className="mer-floor-queue-banner"
              data-testid="merchant-floor-queue-banner"
              data-online={online ? 'true' : 'false'}
              data-queued={String(queuedCount)}
            >
              {!online ? 'Offline, actions queue locally' : null}
              {queuedCount > 0 ? ` · ${queuedCount} queued` : null}
              {queuedCount > 0 && online ? (
                <Button
                  type="button"
                  variant="secondary"
                  className="m09-target ml-inline"
                  onClick={() => void drain()}
                >
                  Sync now
                </Button>
              ) : null}
            </div>
          ) : null}
        </header>
      ) : null}
      <Outlet />
      <PinSignInModal
        open={pinOpen}
        onClose={() => setPinOpen(false)}
        onSuccess={() => markFloorSession(true)}
        title="PIN unlock"
      />
    </div>
  );
}
